import InputText from "../../../../design-system/components/InputText/InputText.jsx";
import styles from "../showroomForm.css";

/**
 * SingleLine is a functional component that renders an input text field
 * with a label. It allows for controlled input management by updating
 * the form data state upon user interaction.
 *
 * @param {Object} props - Component properties.
 * @param {string} props.fieldKey - The key representing the field in the form data object.
 * @param {string} props.label - The label text displayed for the input field.
 * @param {string} props.description - The description text displayed for the input field.
 * @param {Object} props.formData - An object containing the current state of the form data.
 * @param {Function} props.setFormData - A state updater function to modify the formData object.
 * @returns {JSX.Element} A rendered input text field with the specified label and functionality.
 */
export const SingleLine = ({
  fieldKey,
  label,
  description,
  formData,
  setFormData,
  required,
  validate,
  error,
}) => {
  return (
    <div className={styles.formGroup}>
      {label && (
        <h2>
          {label}
          {required && "*"}
        </h2>
      )}
      {description && <p className={styles.description}>{description}</p>}
      <InputText
        name={fieldKey}
        label={label}
        value={
          formData[fieldKey]
            ? (formData[fieldKey].data ?? formData[fieldKey])
            : ""
        }
        onChange={(e) => {
          setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldKey]: e.target.value,
          }));

          if (validate) validate(e);
        }}
        minLength={1}
        maxLength={120}
        required={required}
        width100
        error={error}
        theme={"dark"}
      />
    </div>
  );
};
